let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hVaCh")).then(() => parcelRequire('jsSSp'));